module.exports = __webpack_public_path__ + "img/neudorf-thumb.ae396c9b.jpg";